import { render } from "./ButtonMessengers.vue?vue&type=template&id=528b1a6e&scoped=true"
import script from "./ButtonMessengers.vue?vue&type=script&lang=js"
export * from "./ButtonMessengers.vue?vue&type=script&lang=js"

import "./ButtonMessengers.vue?vue&type=style&index=0&id=528b1a6e&lang=scss&scoped=true"

import exportComponent from "/home/romych/projects/vue.home.zina.design/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-528b1a6e"]])

export default __exports__